import { Avatar, Button, Input, List, Space, Spin } from "antd"
import { getColorByLetter, getColorByObjectId } from "../../../common/helpers"
import DotIcon from "../../../components/icons/DotIcon"
import { useEffect, useMemo, useRef, useState } from "react"
import ChatItem from "../../../components/ChatItem"
import dayjs from "dayjs"
import { DATE_FORMAT_DD_MMM_YYYY, USER_TYPE_ADMINISTRATIVE, USER_TYPE_ORGANIZATION, USER_TYPE_PARTNER } from "../../../constants/constants"
import SendIcon from "../../../components/icons/SendIcon"
import CloseIcon from "../../../components/icons/CloseIcon"
import DeliveredItem from "../../../components/DeliveredItem"
import { io, Socket } from "socket.io-client";
import { getMessageDeliveryInfo, getMessages } from "../../../API/endpoints/Discovery"

let socket: Socket;


interface Props {
  partner: any;
  userProfile: any
}
const Messages = (props: Props) => {
  const { partner, userProfile } = props;


  const [roomId, setRoomId] = useState("");
  const [message, setMessage] = useState("");
  const [chats, setChats] = useState<any[]>([]);
  const [loadingMessages, setLoadingMessages] = useState(true);


  const [deliveredUsers, setDeliveredUsers] = useState<any[]>([]);
  const [infoMessageID, setInfoMessageID] = useState("");

  const [onlineCount, setOnlineCount] = useState(0);

  const messagesEndRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (partner?.discovery_request_id) {
      setLoadingMessages(true)
      setRoomId(`${partner?.discovery_request_id}-${partner?.partner_id}`)

      getMessages(partner?.discovery_request_id, partner?.partner_id).then((res: any) => {
        setChats(res?.data?.map((item: any) => (({
          ...item,
          user: userProfile?.id === item?.sender ? "self" : item?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? "admin" : "org",
          senderName: userProfile?.id === item?.sender ? "self" : item?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? "admin" : item?.senderUser?.user_type == USER_TYPE_ORGANIZATION && item?.senderUser?.organization?.company_name ? item?.senderUser?.organization?.company_name : item?.senderUser?.user_type == USER_TYPE_PARTNER && item?.senderUser?.partnerv2?.name ? item?.senderUser?.partnerv2?.name : item?.senderUser?.first_name,
          senderUserID: userProfile?.id === item?.sender ? userProfile?.id : item?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? userProfile?.id : item?.senderUser?.user_type == USER_TYPE_ORGANIZATION && item?.senderUser?.organization?.id ? item?.senderUser?.organization?.id : item?.senderUser?.user_type == USER_TYPE_PARTNER && item?.senderUser?.partnerv2?.id ? item?.senderUser?.partnerv2?.id : item?.senderUser?.id
        }))) || [])
        setLoadingMessages(false);
      }).catch((err) => {
        console.error("Failed to fetch messages", err);
        setLoadingMessages(false);
      })
    }

  }, [partner, userProfile]);

  useEffect(() => {
    scrollToBottom();
    let deliveredMessages: string[] = []
    chats.forEach((item: any) => {
      if (item?.user !== "self") {
        deliveredMessages.push(item?.id)
      }
    });
    if (deliveredMessages.length > 0 && socket && socket.connected) {
      socket.emit("mark-delivered-and-read", { messageIds: deliveredMessages, userId: userProfile?.id });
      // socket.emit("message-delivered", { messageIds: deliveredMessages, userId: userProfile?.id });
      // socket.emit("mark-read", { messageIds: deliveredMessages, userId: userProfile?.id });
    }



  }, [chats, socket]);

  useEffect(() => {
    socket = io(process.env.REACT_APP_API_URL_SOCKET || "http://localhost:3001", { path: "/aeg" });

    socket.on("connect", () => {
      console.log("Connected:", socket.id);
      joinRoom();
    });

    socket.on("joined-room", (room) => {
      console.log('joined room', room);

    });

    socket.on("new-message", (msg) => {

      setChats((prev) => [...prev, {
        ...msg,
        user: userProfile?.id === msg?.sender ? "self" : msg?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? "admin" : "org",
        senderName: userProfile?.id === msg?.sender ? "self" : msg?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? "admin" : msg?.senderUser?.user_type == USER_TYPE_ORGANIZATION && msg?.senderUser?.organization?.company_name ? msg?.senderUser?.organization?.company_name : msg?.senderUser?.user_type == USER_TYPE_PARTNER && msg?.senderUser?.partnerv2?.name ? msg?.senderUser?.partnerv2?.name : msg?.senderUser?.first_name,
        senderUserID: userProfile?.id === msg?.sender ? userProfile?.id : msg?.senderUser?.user_type == USER_TYPE_ADMINISTRATIVE ? userProfile?.id : msg?.senderUser?.user_type == USER_TYPE_ORGANIZATION && msg?.senderUser?.organization?.id ? msg?.senderUser?.organization?.id : msg?.senderUser?.user_type == USER_TYPE_PARTNER && msg?.senderUser?.partnerv2?.id ? msg?.senderUser?.partnerv2?.id : msg?.senderUser?.id
      }]);
    });

    socket.on("room-user-count", (res) => {
      setOnlineCount(res?.count || 0);
    });

    return () => {
      socket.disconnect();
    };
  }, [roomId]);

  useEffect(() => {
    if (infoMessageID) {
      getMessageDeliveryInfo(infoMessageID).then((res: any) => {
        setDeliveredUsers(res?.data?.map((item: any) => (
          {
            id: item?.id,
            user: item?.deliveredUser?.user_type === USER_TYPE_ADMINISTRATIVE ? "admin" : `${item?.deliveredUser?.first_name || ""} ${item?.deliveredUser?.last_name || ""}`,
            userName: item?.deliveredUser?.user_type == USER_TYPE_ADMINISTRATIVE ? "admin" : item?.deliveredUser?.user_type == USER_TYPE_ORGANIZATION && item?.deliveredUser?.organization?.company_name ? item?.deliveredUser?.organization?.company_name : item?.deliveredUser?.user_type == USER_TYPE_PARTNER && item?.deliveredUser?.partnerv2?.name ? item?.deliveredUser?.partnerv2?.name : item?.deliveredUser?.first_name,
            userId: item?.deliveredUser?.user_type == USER_TYPE_ADMINISTRATIVE ? userProfile?.id : item?.deliveredUser?.user_type == USER_TYPE_ORGANIZATION && item?.deliveredUser?.organization?.id ? item?.deliveredUser?.organization?.id : item?.deliveredUser?.user_type == USER_TYPE_PARTNER && item?.deliveredUser?.partnerv2?.id ? item?.deliveredUser?.partnerv2?.id : item?.deliveredUser?.id,
            date: item?.delivered_at
          }
        )))
      }).catch((err) => {
        console.error("Failed to fetch message delivery details", err);

      })
    }
  }, [infoMessageID])


  const joinRoom = () => {
    socket.emit("join-room", roomId);
  };

  const sendMessage = () => {
    socket.emit("new-message", {
      discovery_request_id: partner?.discovery_request_id, // replace with real UUID
      partner_id: partner?.partner_id, // replace with real UUID
      message,
      message_type: "text",
      sender: userProfile?.id,
    });
    setMessage("");
  };

  const handleCloseInfo = () => {
    setInfoMessageID("");
    setDeliveredUsers([]);
  }

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  const chatList = useMemo(() => {
    const elements = [];

    const today = dayjs().startOf('day');

    for (let i = 0; i < chats.length; i++) {
      const current: any = chats[i];
      const prev = chats[i - 1];

      const currentDate = dayjs(current.timestamp).startOf('day');
      const prevDate = prev ? dayjs(prev.timestamp).startOf('day') : null;

      const isNewDate = !prevDate || !currentDate.isSame(prevDate, 'day');
      const isToday = currentDate.isSame(today, 'day');

      // Insert date divider if it's the first message or date changes
      if (isNewDate) {

        const displayDate = isToday
          ? 'Today'
          : currentDate.format(DATE_FORMAT_DD_MMM_YYYY);

        elements.push(
          <p key={`divider-${currentDate}`} className="self-center text-[10px] bg-[#344054] text-white px-[8px] py-[6px] rounded-[3px] m-0 leading-[10px]">
            {displayDate}
          </p>
        );
      }

      elements.push(
        <ChatItem
          key={current.id || `chat-${i}`}
          data={current}
          prevUser={prev?.user}
          viewInfo={(info) => setInfoMessageID(info?.id)}
        />
      );
    }

    return elements;
  }, [chats]);

  return (
    <div className="w-full">
      <div className="h-[calc(100vh-180px)] mx-auto xl:max-w-[920px] 2xl:max-w-[1010px] bg-[#EFF8FF] mx-[16px] mb-[16px] flex rounded-[8px] overflow-hidden">
        <div className="flex-1 h-full">
          <div className="w-full bg-white px-[16px] py-[8px] items-center  rounded-tl-[8px] flex gap-x-[12px]">
            <Avatar size={'large'} style={getColorByObjectId(partner?.partner?.id)}>{partner?.partner?.name?.charAt(0)}</Avatar>
            <div>
              <p className="text-[13px] font-[500] m-0">{partner?.partner?.name}</p>
              <div className="flex items-center gap-x-[4px]">
                <DotIcon color="#12B76A" />
                <p className="m-0 text-[12px] text-[#475467]">{onlineCount} Online</p>
              </div>
            </div>
          </div>
          <div className="h-[calc(100%-150px)] overflow-auto flex flex-col gap-y-[10px] p-[16px] overflow-scroll-bar">
            {chats.length > 0 ? (
              <>
                {loadingMessages ? (
                  <div className="text-center mt-4">
                    <Spin size="small" />
                  </div>

                ) : (
                  chatList
                )}
                <div ref={messagesEndRef} />
              </>
            ) : (
              <p className="self-center text-[10px] bg-white text-gray-800 px-[8px] py-[6px] rounded-[3px] m-0 leading-[10px]">
                No messages.
              </p>
            )}
          </div>
          <div className="w-full bg-white p-[10px] flex gap-x-[8px] items-end rounded-bl-[8px]">
            <div className="flex-1">
              <Input.TextArea
                className="!bg-[#F2F4F7] !border-0 !shadow-none !resize-none overflow-scroll-bar"
                placeholder="Type your message"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <Button type="primary" icon={<SendIcon />} className="leading-[12px]" onClick={() => sendMessage()} />
          </div>
        </div>
        <div className={`${infoMessageID ? "w-[250px] px-[14px]" : "w-0"} transition-all overflow-hidden py-[10px] bg-white border-l border-[#E4E7EC] rounded-r-[8px]`}>
          <div className="flex justify-between items-center mb-2">
            <p className="text-[12px] font-[500] m-0">Delivered to:</p>
            <Button type="text" icon={<CloseIcon />} className="leading-[12px]" onClick={handleCloseInfo} />
          </div>
          <div className="overflow-auto h-[calc(100%-40px)] overflow-scroll-bar">
            <List
              dataSource={deliveredUsers}
              renderItem={(item) => (
                <List.Item>
                  <DeliveredItem data={item} />
                </List.Item>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Messages